/* Dünne Schicht über fetch: JSON rein, JSON raus, Fehler als deutsche Meldung */
export class ApiError extends Error {
  constructor(public status: number, message: string) { super(message); }
}

/* Wird gerufen, wenn der Server eine bestehende Anmeldung nicht mehr kennt (z. B. Sitzung abgelaufen) */
let onUnauthorized: (() => void) | null = null;
export function setUnauthorizedHandler(fn: () => void) { onUnauthorized = fn; }

/* Runde 340 (Micha: „ein Ladebalken, dass der Nutzer sieht, was Sache ist“): dünner Balken unter der Kopfzeile, sobald eine Anfrage länger als 250 ms läuft.
   Kurze Statusabfragen bleiben unsichtbar. */
let pending = 0; let barTimer = 0;
function netBar(delta: number): void {
  pending = Math.max(0, pending + delta); if (typeof document === 'undefined') return;
  let el = document.getElementById('netbar'); if (!el) { el = document.createElement('div'); el.id = 'netbar'; el.setAttribute('role', 'progressbar'); el.setAttribute('aria-label', 'Daten werden geladen'); el.innerHTML = '<i></i>'; document.body.appendChild(el); }
  if (pending > 0) { if (!barTimer && !el.classList.contains('on')) barTimer = window.setTimeout(() => { barTimer = 0; if (pending > 0) document.getElementById('netbar')?.classList.add('on'); }, 250); }
  else { window.clearTimeout(barTimer); barTimer = 0; el.classList.remove('on'); }
}
/* Runde 342: Zähler der schreibenden Anfragen — Zwischenspeicher der Ansichten gelten nur bis zur nächsten Änderung */
let mutations = 0; export const mutationCount = () => mutations;
async function call<T>(method: string, url: string, body?: unknown, signal?: AbortSignal): Promise<T> {
  if (method !== 'GET' && !/\/api\/goals\/(preview|verify|verify-ki)$|\/change-preview$|\/api\/login$/.test(url)) mutations++;
  netBar(1); try { return await callRaw<T>(method, url, body, signal); } finally { netBar(-1); }
}
async function callRaw<T>(method: string, url: string, body?: unknown, signal?: AbortSignal): Promise<T> {   /* signal: Abbrechen durch den Nutzer (Runde 276) — fetch wirft dann AbortError */
  const res = await fetch(url, {
    method,
    headers: body !== undefined ? { 'Content-Type': 'application/json' } : undefined,
    body: body !== undefined ? JSON.stringify(body) : undefined,
    credentials: 'same-origin',
    signal
  });
  const text = await res.text();
  let data: any = null;
  try { data = text ? JSON.parse(text) : null; } catch { data = null; }
  if (res.status === 401 && onUnauthorized && !url.startsWith('/api/login') && !url.startsWith('/api/me') && !url.startsWith('/api/setup')) onUnauthorized();
  if (!res.ok) throw new ApiError(res.status, (data && data.error) || `Fehler ${res.status}`);
  return data as T;
}

export const api = {
  get: <T>(url: string) => call<T>('GET', url),
  post: <T>(url: string, body?: unknown, signal?: AbortSignal) => call<T>('POST', url, body ?? {}, signal),
  patch: <T>(url: string, body: unknown) => call<T>('PATCH', url, body),
  put: <T>(url: string, body: unknown) => call<T>('PUT', url, body),
  del: <T>(url: string) => call<T>('DELETE', url)
};
